import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDocs,
  query,
  serverTimestamp,
  where,
} from 'firebase/firestore';
import { auth, db } from './firebase';

const normaliseAnswer = (value) => {
  if (typeof value === 'string') return value.trim();
  return value;
};

export const formService = {
  async listResponses() {
    if (!auth.currentUser) {
      throw new Error('You must be signed in to view form responses.');
    }

    const snapshot = await getDocs(query(
      collection(db, 'sharabl-form-responses'),
      where('ownerId', '==', auth.currentUser.uid),
    ));

    return snapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        id: doc.id,
        ...data,
        submittedAt: data.submittedAt?.toDate ? data.submittedAt.toDate().toISOString() : data.submittedAt,
      };
    }).sort((a, b) => new Date(b.submittedAt || 0) - new Date(a.submittedAt || 0));
  },

  async submitResponse(link, answers, options = {}) {
    if (!link?.id) {
      throw new Error('This form is missing a saved link reference.');
    }

    const payload = {
      linkId: link.id,
      linkSlug: link.slug || '',
      linkTitle: link.title || '',
      ownerId: link.ownerId || '',
      assetId: options.asset?.id || options.assetId || '',
      assetTitle: options.asset?.title || options.assetTitle || '',
      formTitle: options.form?.title || link.form?.title || '',
      answers: Object.fromEntries(
        Object.entries(answers || {}).map(([fieldId, value]) => [fieldId, normaliseAnswer(value)]),
      ),
      submittedAt: serverTimestamp(),
    };

    const created = await addDoc(collection(db, 'sharabl-form-responses'), payload);
    return { ...payload, id: created.id, submittedAt: new Date().toISOString() };
  },

  async removeResponse(responseOrId) {
    if (!auth.currentUser) {
      throw new Error('You must be signed in to remove form responses.');
    }

    const id = typeof responseOrId === 'string' ? responseOrId : responseOrId?.id;
    if (!id) {
      throw new Error('This form response is missing an ID.');
    }

    await deleteDoc(doc(db, 'sharabl-form-responses', id));
    return id;
  },
};
